import React, { useCallback, useEffect, useState } from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import blogFetch from "../../axios/config";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import Loading from "../../components/Loading";
import { FormatDate } from "../../utils/DataUtils";
import "./styleHistorico.css";

interface HistoricoItem {
    tela: string;
    data: Date;
    criado: string;
    ordens: string[];
    status: string[];
    lote: string[];
}

export const HistoricoTelas: React.FC = () => {
    const [historicoTelas, setHistoricoTelas] = useState<HistoricoItem[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedItems, setSelectedItems] = useState<string[]>([]);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchHistorico = useCallback(async () => {
        setIsLoading(true);
        try {
            const { data } = await blogFetch.get<HistoricoItem[]>("SAGA_ListaProducao/getHistorico");
            setHistoricoTelas(data);
        } catch (error) {
            console.error("Erro ao buscar histórico:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchHistorico();
    }, [fetchHistorico]);

    const handleCheckboxChange = (tela: string) => {
        setSelectedItems(prev =>
            prev.includes(tela)
                ? prev.filter(item => item !== tela)
                : [...prev, tela]
        );
    };

    const handleReimprimir = async () => {
        if (selectedItems.length === 0) {
            alert("Selecione pelo menos um item para reimprimir");
            return;
        }

        const itemsToReimprimir = selectedItems;

        await blogFetch
            .post("SAGA_ListaProducao/telas_reimprimir", itemsToReimprimir, {
                responseType: "blob"
            })
            .then(response => {
                if (response.data) {
                    const blob = new Blob([response.data]);
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "Reimpressao.xlsx";
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                    setSelectedItems([]);
                }
            })
            .catch(error => {
                console.error("Erro ao baixar o arquivo:", error);
            });
    };

    const historicoFiltrado = historicoTelas.filter(item =>
        item.tela.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <Navbar />
            <Sidebar />
            <div className="app_body">
                <form>
                    <h2 className="historic-title">Histórico de Telas</h2>

                    <button
                        type="button"
                        onClick={handleReimprimir}
                        disabled={isLoading || selectedItems.length === 0}
                        className="reimprimir-btn"
                    >
                        Reimprimir
                    </button>

                    <input
                        type="text"
                        placeholder="Pesquisar por nome da tela..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input"
                    />

                    {isLoading ? (
                        <Loading />
                    ) : (
                        historicoFiltrado.map(({ tela, data, criado, ordens, status, lote }) => (
                            <div key={tela} className="historic-item-container">
                                <Accordion className="historic-accordion">
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        className="accordion-summary"
                                    >
                                        <input
                                            type="checkbox"
                                            checked={selectedItems.includes(tela)}
                                            onChange={() => handleCheckboxChange(tela)}
                                            className="checkbox-container"
                                        />
                                        <div className="accordion-title">
                                            {tela} - {FormatDate(data)} - {criado}
                                        </div>
                                    </AccordionSummary>
                                    <AccordionDetails className="accordion-details">
                                        <table className="historic-table">
                                            <thead>
                                                <tr className="table-header">
                                                    <th>Ordem</th>
                                                    <th>Status</th>
                                                    <th>Lote</th>
                                                </tr>
                                            </thead>
                                            <tbody className="table-body">
                                                {ordens.map((ordem, i) => (
                                                    <tr key={i} className="table-row">
                                                        <td className="table-cell">{ordem}</td>
                                                        <td className="table-cell">{status[i]}</td>
                                                        <td className="table-cell">{lote[i]}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        ))
                    )}
                </form>
            </div>
        </>
    );
};
